"use strict";
// write your code here
var logo = document.querySelector(".logo");
var promise1 = new Promise(function(resolve) {
    logo.addEventListener("click", function() {
        resolve();
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("Promise was rejected"));
    }, 3000);
});
function showSuccessMessage() {
    var message = document.createElement("div");
    message.classList.add("message");
    message.textContent = "Promise was resolved!";
    document.body.append(message);
}
function showErrorMessage() {
    var message = document.createElement("div");
    message.classList.add("message", "error-message");
    message.textContent = "Promise was rejected!";
    document.body.append(message);
}
promise1.then(showSuccessMessage);
promise1.catch(showErrorMessage);
promise2.then(showSuccessMessage);
promise2.catch(showErrorMessage);

//# sourceMappingURL=index.19184a1a.js.map
